import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

// Custom Turbo Stream action to scroll message pane to bottom
Turbo.StreamActions.scroll_message_pane_to_bottom = function () {
    setTimeout(() => {
        const target = this.targetElements[0];
        if (target) {
            target.scrollTop = target.scrollHeight;
        }
    }, 0);
};

function getCsrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (!token) {
        throw new Error('CSRF token not found');
    }
    return token;
}

function markMessagesAsRead(bookingRequestId) {
    return fetch(`/booking_requests/${bookingRequestId}/mark_messages_as_read`, {
        method: 'PATCH',
        headers: {
            'X-CSRF-Token': getCsrfToken(),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });
}

// Custom Turbo Stream action to mark unread messages as read
// This is triggered by the server when a user has unread messages
Turbo.StreamActions.mark_unread_messages_as_read = function () {
    const container = this.targetElements[0];
    if (!container) return;

    const bookingRequestId = container.getAttribute('data-booking-request-id');
    if (!bookingRequestId) return;

    markMessagesAsRead(bookingRequestId).then((response) => {
        if (!response.ok) {
            console.error('Failed to mark messages as read for booking request: ' + bookingRequestId);
        }
    }).catch(() => {
        console.error('Error marking messages as read for booking request: ' + bookingRequestId);
    });
};

export default class extends Controller {
    static targets = ["container"]

    connect() {
        Turbo.StreamActions.scroll_message_pane_to_bottom.call({
            targetElements: [this.containerTarget]
        });
    }
}
